import PropTypes from 'prop-types';
import { TableCell, Table, TableHead, TableRow, TableBody, Box } from '@material-ui/core';

const styles = {
  tableRow: {
    '&:last-child td, &:last-child th': { border: 0 }
  }
};

VMEnvSummary.propTypes = {
  vm: PropTypes.object
};
export default function VMEnvSummary({ vm }) {
  return (
    <Box data-testid="env-summary">
      <Table size="small" aria-label="Environment Details">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell align="right">Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {vm.env.map((env) => (
            <TableRow key={env.key} sx={styles.tableRow}>
              <TableCell>{env.name}</TableCell>
              <TableCell align="right">{env.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}
